export enum QueryType {
  PAIR = "PAIR",
  PAIRS_SWAP_FEES = "PAIRS_SWAP_FEES",
}
